const fontFamily = {
  NOTO: "'Noto Sans KR', sans-serif",
  ROBOTO: "'Roboto', sans-serif",
  PRETENDARD: "'Pretendard'",
};

export default fontFamily;
